/* eslint-disable no-redeclare */
class KtznWebsocketError extends Error {
  /** Error type */
  type: KtznWebsocketError.Type;

  constructor(type: KtznWebsocketError.Type = KtznWebsocketError.Type.general, ...params: any[]) {
    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(...params);

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, KtznWebsocketError);
    }

    this.name = "KtznWebsocketError";
    // Custom debugging information
    this.type = type;
  }
}

namespace KtznWebsocketError {
  export enum Type {
    general = "General error",
    network = "Network error",
    noToken = "No auth token",
    noGraphqlObject = "No GraphQL object error",
    noEvent = "No event object",
    noWebsocketConnection = "No websocket connection",
  }
}

export default KtznWebsocketError;
